import React from "react";
import { Provider } from "components/vneid-job/VNeIDJobContext";
import { VNeIDJobList } from "components/vneid-job/VNeIDJobList";

export const VNeIDJobs = () => {
    return (
        <Provider>
            <VNeIDJobList />
        </Provider>
    );
};
